import React from "react";
import "./App.css";

function About() {
  return <div className="about">
  <div className="aboutHeader"></div>
    <div className="columns">
      <h1>What?</h1>
      <p>
        Approximate is a Swedish demogroup founded in 2001. To the uninvited, that does not say much. 
        So in other terms, we are a group of creative individuals who make realtime audiovisual presentations on computers within the
        the computer subculture known as the Demoscene.</p> 
        <p>Through the means of procedural generated graphics, sound synthesis and executable 
        compression we specialize in creating size limited audiovisual presentations, in our case, limited to no larger than 65,536 bytes
        capable of rendering high quality visuals and music in realtime. 
        The same type of visuals normally seen in modern day computer games.
      
        </p>
        <br/><br/>
      <h2>Why?</h2>
      <p>
        We do this for the technical challange, the thrill of the competition and for the simple reason that its fun.
        Ofcourse there is also the social aspect of being involved in the demoscene in general wich is a great motivator.
        Our aim to create something noone else have been able to make. Be that, fitting an insane amont of conent into
        a 64k intro, or using new technology while being limited to such a tiny size. 
        We want to astonish people, doing the seemingly impossible.
      </p>

      <h2>Members</h2>
      <p>
      <b>Cryptic</b> (Jonas Fredriksson)is the founder of Approximate and the main coder.
      He is the person behind the various custom tools we use in creating our intros. Everything from the texture generator, bla bla, bla bla to the 
      software synthesizer and music tracker are his brainchilds. Cryptic allso designs our 64k intros.
      </p>

      <p>
      <b>Velo</b> (Andreas Ahlborg) is the musician of the group.
        Using the groups custom synth he is responsible for the music of sevral of approximates demos and 64k intros and has with some 
        success allso competed in stand alone music comeptitions at demoparties over ther years. 
        He has been known of making small amounts of graphics for a few intros when time has been short.
      </p>

      <p>
      <b>Meteorik</b> (Giles Constant) was a coder and musician in Approximate.
        Joining in around 2005, he quickly showed an interest in sound synthesis and created Approximates first custom
        synths used in our earlier productions wich he allso made the music for. 
        Giles sadly passed away in 2012. He was deeply involved in the demoscene in various ways and his
        death is a great loss to demoscene as a whole. He will never be forgotten.
      </p>
 
    </div>
  </div>;
}

export default About;



// WEBPACK FOOTER //
// ./src/about.js